/** Small glowing status dot. Used in the hero status chips. */
export function Pulse({ color = 'var(--color-ok)', size = 7 }: { color?: string; size?: number }) {
  return (
    <span
      aria-hidden
      className="inline-block shrink-0 rounded-full"
      style={{
        width: size,
        height: size,
        background: color,
        boxShadow: `0 0 10px ${color}`,
      }}
    />
  );
}
